<template>
    <div>
        <v-row class="d-flex justify-center">
            <v-col cols="12" lg="10" xl="9">
                <Datatable :headers="tableHeaders" :items="targetings" title="Targetings" :items-per-page="-1"
                           @click:row="emitClicked"
                           @click:edit="emitClicked"
                           @click:delete="emitClicked($event, true)"
                >
                    <template #top>
                        <Button v-if="$vuetify.breakpoint.mdAndUp" icon="mdi-plus" :color="ada.blue"
                                @click="emitClicked(null)"
                        >Targeting hinzufügen
                        </Button>
                    </template>
                </Datatable>
            </v-col>
        </v-row>
        <AddEditTargetingDialog v-model="showDialog"></AddEditTargetingDialog>
        <DeleteTargetingDialog v-model="showDeleteDialog"></DeleteTargetingDialog>
    </div>
</template>

<script>
import ada from "../../../scss/ada_colors.scss";
import Datatable from "../../../components/Tables/Datatable";
import Button from "../../../components/buttons/Button";
import AddEditTargetingDialog from "../Dialogs/AddEditTargetingDialog";
import DeleteTargetingDialog from "../Dialogs/DeleteTargetingDialog";
import Utils from "../../../scripts/Utils";

export default {
    name: "Settings_Targetings",
    components: {DeleteTargetingDialog, AddEditTargetingDialog, Button, Datatable},
    data: () => {
        return {
            tableHeaders: [
                {text: 'Name', value: 'Name', width: '80%'},
                {text: 'Erstellt am', value: 'Created', width: '250px'},
                {text: 'Aktion', value: 'action', width: '100px', sortable: false},
            ],
            showDialog: false,
            showDeleteDialog: false,
            ada
        }
    },
    computed: {
        vuexState() {
            return this.$store.state.settings;
        },
        targetings() {
            let tableBody = this.vuexState.targetings ? this.vuexState.targetings : [];
            tableBody.forEach((item) => {
                item.action = ['edit', 'delete'];
                item.Created = Utils.formatDate(item.Created);
            })
            return tableBody;
        },
    },
    methods: {
        emitClicked(item, deleting = false) {
            this.$emit('click', item, deleting, this);
        },
    },
}
</script>

<style scoped>

</style>